import type { PiniaPlugin } from 'pinia'
import { lodashDeepClone } from 'utils'

const createDisposePlugin: PiniaPlugin = (context) => {
  const initialState = lodashDeepClone(context.store.$state)
  context.store.$dispose = () => {
    context.store.$patch(initialState)
  }
}

export const pinia = createPinia()

pinia.use(createDisposePlugin)
